import {
  AE,
  JA,
  SO,
  EN,
  ES,
  FA,
  ZH,
  RU,
} from "./images";

const config = {
  skrill: {
    SKRILL_PAY_TO_EMAIL: process.env.SKRILL_PAY_TO_EMAIL,
    SKRILL_STATUS_URL: process.env.SKRILL_STATUS_URL,
    SKRILL_CURRENCY: process.env.SKRILL_CURRENCY,
    SKRILL_PAYMENT_METHODS: process.env.SKRILL_PAYMENT_METHODS,
    SKRILL_RECEIPENT_DESCRIPTION: process.env.SKRILL_RECEIPENT_DESCRIPTION,
    SKRIL_LOGO: process.env.SKRIL_LOGO,
    SKRIL_LANGUAGE: process.env.SKRIL_LANGUAGE,
    SKRIL_DETAIL1_DESCRIPTION: process.env.SKRIL_DETAIL1_DESCRIPTION,
    SKRIL_DETAIL1_TEXT: process.env.SKRIL_DETAIL1_TEXT,
  },
  paysafeKeys: {
    sdk: process.env.PAYSAFE_SDK,
    publicApiKey: process.env.PAYSAFE_PUBLIC_API_KEY,

  },
  QUBEPAY_CHECKOUT_URL: process.env.QUBEPAY_CHECKOUT_URL,
  CASHU_CHECKOUT_URL: process.env.CASHU_CHECKOUT_URL,
  apiHost: 'https://service.accuindex.com', //  process.env.API_HOST || 
  englishLanguage: process.env.ENLIGSH_LANGUAGE || 'en-us',
  arabicLanguage: 'ar-ae',
  japneseLanguage: 'ja-jp',
  languages: [
    {
      title: 'English',
      titleCode: 'ENG',
      flag: EN,
      key: 'en-us',
      key1: 'en-gb',
    },
    {
      title: 'عربي',
      titleCode: 'AR',
      flag: AE,
      key: 'ar-ae',
      key1: 'ar-ae',
    },
    {
      title: 'Japnese',
      titleCode: 'JPN',
      flag: JA,
      key: 'ja-jp',
      key1: 'jp',
    },
    {
      title: 'Sorani',
      titleCode: 'SOR',
      flag: SO,
      key: 'so-kr',
      key1: 'so',
    },
    {
      title: 'Russian',
      titleCode: 'RUS',
      flag: RU,
      key: 'ru',
      key1: 'ru'
    },
    {
      title: 'Spanish',
      titleCode: 'SPA',
      flag: ES,
      key: 'es-es',
      key1: 'es',
    },
    {
      title: 'Farsi',
      titleCode: 'FAR',
      flag: FA,
      key: 'fa-ir',
      key1: 'fa',
    },
    {
      title: 'Chinese',
      titleCode: 'CHI',
      flag: ZH,
      key: 'zh-cn',
      key1: 'zh',
    }
  ],
  env: process.env.DEV_ENV || 'development'
}
export default config

